import { Layout, AddExchange } from '@/views/exchange';

export default {
    path: '/exchange',
    component: Layout,
    children: [
        { path: 'add', component: AddExchange },
    ]
};
